import { Text } from 'react-native-paper';
import useFormStyle from '@/components/Styles/useFormStyle';
import { useRouter } from 'expo-router';
import ScreenMargin from '@/components/ScreenMargin';
import { useForm } from 'react-hook-form';
import { InsertPatientMutationVariables, useInsertPatientMutation } from '@/data/data';
import { useUserContext } from '@/components/Auth/UserContext';
import { useState } from 'react';
import Form from '@/components/Form/Form';
import { View } from 'react-native';
import FTextInput from '@/components/Form/TextInput';
import BaseContainer from '@/components/BaseContainer';
import DatePickerInput from '@/components/Form/DatePickerInput';
import { AvailableValidationRules } from '@/components/Form/validation';
import FormSectionFooter from '@/components/Form/FormSectionFooter';
import { useTranslation } from 'react-i18next';
import { useToast } from 'react-native-toast-notifications';

const AjouterPatientPage = () => {
  const { user } = useUserContext();
  const router = useRouter();
  const toast = useToast();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [insertPatient] = useInsertPatientMutation({
    onCompleted: (data) => {
      if (data?.insertPatientOne) {
        toast.show(t('Patient créé avec succès'), { type: 'success' });
        router.back();
      } else {
        toast.show('Erreur: la création a retourné une réponse vide', { type: 'error', duration: 10000 });
      }
      setLoading(false);
    },
    onError: (error) => {
      console.error('Erreur création patient:', error);
      toast.show(`Erreur: ${error.message}`, { type: 'error', duration: 10000 });
      setLoading(false);
    },
    fetchPolicy: 'network-only',
  });
  const form = useForm<InsertPatientMutationVariables>();

  const styles = useFormStyle();

  return (
    <ScreenMargin>
      <BaseContainer withScrollView={'keyboardAware'}>
        <Text style={styles?.headerForm}>{t('Ajouter un patient')}</Text>

        <Form<InsertPatientMutationVariables> {...form}>
          <View style={styles?.bodyForm}>
            <View style={styles?.groupForm}>
              <Text style={styles?.titleGroupForm}>{t('Données')}</Text>
              <FTextInput
                name={'nom'}
                label={'Nom'}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
              <FTextInput
                name={'prenom'}
                label={'Prénom'}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
              <DatePickerInput
                name={'birthday'}
                label={t('Date de naissance')}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
            </View>
          </View>
          <View style={styles?.footerForm}>
            <FormSectionFooter
              saveLoading={loading}
              saveDisabled={loading}
              onPress={form.handleSubmit(async (data) => {
                if (!user?.id) {
                  toast.show(t('Erreur: utilisateur non connecté'), { type: 'error' });
                  return;
                }

                setLoading(true);
                try {
                  await insertPatient({
                    variables: {
                      ...data,
                      chirurgienId: user.id,
                    },
                  });
                  // La redirection et setLoading(false) sont gérés dans onCompleted/onError
                } catch (error: any) {
                  console.error('Erreur inattendue:', error);
                  toast.show(`Erreur: ${error?.message || error}`, { type: 'error', duration: 10000 });
                  setLoading(false);
                }
              })}
            />
          </View>
        </Form>
      </BaseContainer>
    </ScreenMargin>
  );
};

export default AjouterPatientPage;
